import React, { useState, useEffect, useContext } from "react";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { useDebounce } from 'primereact/hooks';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useNavigate, useParams } from "react-router-dom";
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';
import { FilterMatchMode, FilterOperator, FilterService } from 'primereact/api';
import { appContext } from '../../../App'
import { getPathByName } from "../../../routesUtils"

function Portals() {
    const navigate = useNavigate();
    const [portals, setPortals] = useState([]);
    const [search, debouncedSearch, setSearch] = useDebounce('', 2000);
    const AppContext = useContext(appContext)
    const [filters, setFilters] = useState({
        name: { value: null, matchMode: FilterMatchMode.CONTAINS },
        contact_email: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        code: { value: null, matchMode: FilterMatchMode.CONTAINS },
        enabled: { value: null, matchMode: FilterMatchMode.EQUALS },
    });

    const loadPortals = () => {
        let fields = [
            'portals.id',
            'portals.name',
            'portals.contact_email',
            'portals.enabled',
            'portals.code'
        ]
        let params = [{key:'include',value:fields.join(',')}]
        if (search.length > 0) params.push({ key: "search", value: search });
        AppContext.api.getRecords("portals", params).then((res) => {
            setPortals(res.data.records);
        });
    }

    useEffect(() => {
        loadPortals()
    }, [debouncedSearch]);

    const startContent = (
        <React.Fragment>
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText
                    value={search}
                    placeholder="Rechercher un portail"
                    onChange={(e) => setSearch(e.target.value)} />
            </span>
        </React.Fragment>
    );

    const endContent = (
        <React.Fragment>
            <Button
                label="Ajouter"
                icon="pi pi-check"
                severity="success"
                onClick={
                    () => navigate(getPathByName('configCreatePortal'))
                }>
            </Button>
        </React.Fragment>
    );

    const actionBtns = (item) => {
        return (
            <React.Fragment>
                <span className="p-buttonset">
                    <Button
                        icon="pi pi-pencil"
                        onClick={() => navigate(getPathByName('configEditPortal', { portalId: item.id }))}
                        text raised
                    ></Button>
                    <Button
                        icon="pi pi-trash"
                        onClick={(event) => confirmRemovePortal(event, item)}
                        severity="danger"
                        text raised
                    ></Button>
                </span>
            </React.Fragment>
        );
    };

    const confirmRemovePortal = (event, portal) => {

        const accept = () => {
            AppContext.api.deleteRecords("portals", [portal.id]).then((res) => {
                loadPortals()
            });
        };

        confirmPopup({
            target: event.currentTarget,
            message: 'Voulez-vous supprimer ce portail?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            defaultFocus: 'reject',
            accept
        });
    };

    const enabledBody = (field) => {
        return field.enabled ? <strong>Activé</strong> : <span>Désactivé</span>
    };

    const enabledRowFilterTemplate = (options) => {
        return <Dropdown
            value={options.value}
            options={[{ value: true, label: 'Activé' }, { value: false, label: 'Désactivé' }]}
            onChange={(e) =>
                options.filterApplyCallback(e.value)}
            placeholder="Statut"
            className="p-column-filter"
            showClear
            style={{ minWidth: '12rem' }} />
    };

    return (
        <React.Fragment>
            <ConfirmPopup />
            <Card
                className="flex-grow-1 shadow-none border-1 surface-border fullHeightCard noPaddingCard"
                header={
                    <Toolbar
                        start={startContent}
                        end={endContent}
                        className="shadow-none border-bottom-1 surface-border border-noround-bottom"
                    />
                }
            >
                <DataTable
                    paginator
                    rows={10}
                    rowsPerPageOptions={[10, 25, 50]}
                    value={portals}
                    tableStyle={{ minWidth: "50rem" }}
                    scrollable
                    scrollHeight="flex"
                    className="fullHeightTable"
                    sortMode="multiple"
                    removableSort
                    globalFilterFields={['name', 'code', 'contact_email']}
                    filters={filters}
                >
                    <Column field="name" header="Nom" filter sortable></Column>
                    <Column field="code" header="Code" filter sortable></Column>
                    <Column field="contact_email" header="Email" filter sortable></Column>
                    <Column field="enabled" header="Statut" body={enabledBody}
                        dataType="boolean"
                        filter
                        filterElement={enabledRowFilterTemplate}
                        sortable></Column>
                    <Column header="" body={actionBtns} style={{ width: '85px' }}></Column>
                </DataTable>
            </Card>
        </React.Fragment>
    );
}

export default Portals;
